import { render, staticRenderFns } from "./SnsPostHedgeText.vue?vue&type=template&id=cdd9e570&"
import script from "./SnsPostHedgeText.vue?vue&type=script&setup=true&lang=js&"
export * from "./SnsPostHedgeText.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports